var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1493,316.7a1.065,1.065,0,0,0,.135-1.279l-.736-1.223a1.166,1.166,0,0,0-1.222-.528l-1.51.3a3.638,3.638,0,0,1-2.462-.4l-.022-.012a3.393,3.393,0,0,1-1.583-1.842l-.487-1.4a1.145,1.145,0,0,0-1.088-.752h-1.472a1.143,1.143,0,0,0-1.087.752l-.489,1.4a3.388,3.388,0,0,1-1.582,1.841l-.022.012a3.639,3.639,0,0,1-2.462.4l-1.509-.3a1.167,1.167,0,0,0-1.223.528l-.736,1.223a1.065,1.065,0,0,0,.135,1.279l1,1.082a3.33,3.33,0,0,1,.895,2.265v.025a3.33,3.33,0,0,1-.895,2.265l-1,1.082a1.065,1.065,0,0,0-.135,1.279l.736,1.223a1.167,1.167,0,0,0,1.223.528l1.51-.3a3.636,3.636,0,0,1,2.461.4l.022.012a3.4,3.4,0,0,1,1.583,1.841l.488,1.4a1.143,1.143,0,0,0,1.087.752h1.472a1.145,1.145,0,0,0,1.088-.752l.488-1.4a3.389,3.389,0,0,1,1.582-1.841l.022-.012a3.635,3.635,0,0,1,2.462-.4l1.51.3a1.165,1.165,0,0,0,1.222-.528l.736-1.223a1.065,1.065,0,0,0-.135-1.279l-1.024-1.109a3.28,3.28,0,0,1-.869-2.237v-.025a3.277,3.277,0,0,1,.87-2.237Zm-9.712,6.36a3,3,0,1,1,3.128-3A3.066,3.066,0,0,1,1483.292,323.06Z",
    transform: "translate(-1473.292 -309.56)",
    fill: "#002b49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.917c4614ea0adceba58284b3817ce80f.svg";
export { ForwardRef as ReactComponent };